import styled, { css } from 'styled-components'

import {
  type CatalogItemTagVariant,
  CatalogItemTagVariants,
} from '../../../value-objects/CatalogItemTag'

const COMPACT_VARIANTS = new Set<CatalogItemTagVariant>([
  CatalogItemTagVariants.STRONG,
  CatalogItemTagVariants.MUTED,
  CatalogItemTagVariants.DEAL,
])

export const CatalogItemTagLayoutStyled = styled.div<{
  $variant: CatalogItemTagVariant
  $hasLeadingAsset: boolean
}>`
  display: inline-flex;
  align-items: center;
  gap: ${(props) => props.theme.space.xsmall};
  padding: ${(props) =>
    `${props.theme.typography.pxToRem(
      COMPACT_VARIANTS.has(props.$variant) ? 2 : 4
    )} ${props.theme.space.small}`};
  padding-left: ${(props) =>
    props.$hasLeadingAsset
      ? props.theme.space.xsmall
      : props.theme.space.small};
  border-radius: ${(props) => props.theme.typography.pxToRem(4)};

  ${(props) => {
    switch (props.$variant) {
      case CatalogItemTagVariants.SUCCESS:
        return css`
          background: ${props.theme.colors.badge.success.background};
          color: ${props.theme.colors.badge.success.content};
        `
      case CatalogItemTagVariants.WARNING:
        return css`
          background: ${props.theme.colors.badge.warning.background};
          color: ${props.theme.colors.badge.warning.content};
        `
      case CatalogItemTagVariants.STRONG:
        return css`
          background: ${props.theme.colors.badge.highPriority.background};
          color: ${props.theme.colors.white};
        `
      case CatalogItemTagVariants.MUTED:
        return css`
          background: ${props.theme.colors.badge.inactive.background};
          color: ${props.theme.colors.badge.inactive.content};
        `
      case CatalogItemTagVariants.DEAL:
        return css`
          background: ${props.theme.colors.globalCommand.dealBadgeBackground};
          color: ${props.theme.colors.white};
        `
      default:
        return css`
          border: ${props.theme.typography.pxToRem(1)} solid
            ${props.theme.colors.badge.neutral.border};
          background: ${props.theme.colors.badge.neutral.background};
          color: ${props.theme.colors.badge.neutral.content};
        `
    }
  }}
`
